/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { TextDirective } from '../../directive/text.directive';
import { TextModel } from '@typescript-kit/view';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'label[kitModel]',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelComponent extends TextDirective {

  get hostClass(): string {
    return 'kit-label';
  }

  @Input()
  set kitModel(value: TextModel | string) {
    this.text = value;
  }

  get kitModel(): TextModel | string {
    return this.text;
  }

}
